<h2 mat-dialog-title class="dialog-title">Create Variation</h2>
<div class="dialog-header-fixed">
  <div class="input-row" [formGroup]="templateForm">
    <!--        <mat-form-field appearance="outline" class="me-3">-->
    <!--            <mat-label>Effective Date</mat-label>-->
    <!--            <input matInput [matDatepicker]="picker" [value]="effectiveDate" (dateChange)="onDateChange($event)">-->
    <!--            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>-->
    <!--            <mat-datepicker #picker></mat-datepicker>-->
  <!--        </mat-form-field>-->
  @if (variationTemplates.length > 0) {
    <mat-form-field appearance="outline" floatLabel="always" class="header-selections">
      <mat-label>Variation Template</mat-label>
      <mat-select formControlName="template" (selectionChange)="onTemplateChange()" placeholder="Select a template...">
        @for (template of variationTemplates; track template) {
          <mat-option
            [value]="template.id"
            matTooltip="{{template.description}}">
            {{ template.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
  <mat-form-field appearance="outline" floatLabel="always" class="header-selections">
    <mat-label>Location Set Type</mat-label>
    <mat-select formControlName="locationSetType" (selectionChange)="onLocationSetTypeChange($event)">
      @for (locationType of locationSetTypes; track locationType) {
        <mat-option [value]="locationType">
          {{ locationType.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline" floatLabel="always" class="header-selections">
    <mat-label>Location Set</mat-label>
    <input matInput
      formControlName="location"
      [matAutocomplete]="auto"
      placeholder="Search location sets...">
    <mat-autocomplete #auto="matAutocomplete"
      [displayWith]="displayLocationSet.bind(this)"
      (optionSelected)="onLocationSelected($event)">
      @for (locationSet of filteredLocationSets | async; track locationSet) {
        <mat-option [value]="locationSet">
          {{ locationSet.name }} ({{ locationSet.tag }})
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</div>
</div>
<mat-dialog-content class="dialog-content">
  @if (formReady) {
    <mat-tab-group [(selectedIndex)]="selectedTabIndex">
      <!-- Metadata Tab -->
      <mat-tab label="Metadata">
        <mat-card class="form-card">
          <form [formGroup]="form" class="form-grid">
            @for (formField of metadataAttributes; track formField) {
              <div class="form-field-wrapper">
                <label class="grid-label" [matTooltip]="formField.description">
                  {{ formField.name }}
                  @if (formField.required) {
                    <span class="required-field">*</span>
                  }
                </label>
                <div class="form-field-input">
                  @if (formField.type === 'TEXT') {
                    <div>
                      <mat-form-field appearance="fill" class="flex-align-center flex-100">
                        <input matInput [formControlName]="formField.jsonProperty" [type]="'text'" class="flex-100">
                        @if (form.get(formField.jsonProperty)?.hasError('required')) {
                          <mat-error>
                            {{ formField.name }} is required
                          </mat-error>
                        }
                        @if (form.get(formField.jsonProperty)?.hasError('duplicateVariationLabel')) {
                          <mat-error>
                            A variation with this label already exists
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  }
                  @if (formField.type === 'TEXTAREA') {
                    <div>
                      <mat-form-field appearance="fill" class="flex-align-center flex-100">
                        <textarea matInput
                          cdkTextareaAutosize
                          cdkAutosizeMinRows="3"
                          [formControlName]="formField.jsonProperty" class="flex-100">
                        </textarea>
                        @if (form.get(formField.jsonProperty)?.hasError('required')) {
                          <mat-error>
                            {{ formField.name }} is required
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                  }
                </div>
              </div>
            }
          </form>
        </mat-card>
      </mat-tab>
      <!-- Attribute Overrides Tab -->
      <mat-tab label="Attribute Overrides">
        <mat-card class="form-card">
          @if (overrideAttributes.length === 0) {
            <div class="no-attributes-message">
              <p>No attribute overrides available for this template.</p>
            </div>
          }
          @if (overrideAttributes.length > 0) {
            <form [formGroup]="form" class="form-grid">
              @if (form.hasError('atLeastOneRequired') && overrideAttributes.length > 1) {
                <div class="info-message-container mb-4 negative-margin">
                  <mat-icon>info</mat-icon>
                  <span>At least one override field must be filled out</span>
                </div>
              }
              @for (formField of overrideAttributes; track formField) {
                <div class="form-field-wrapper">
                  <label class="grid-label" [matTooltip]="formField.description">
                    {{ formField.name }}
                    @if (formField.required) {
                      <span class="required-field">*</span>
                    }
                  </label>
                  <div class="form-field-input">
                    @if (formField.type === 'TEXT') {
                      <div>
                        <mat-form-field appearance="fill" class="flex-align-center flex-100">
                          <input matInput [formControlName]="formField.jsonProperty" [type]="'text'" class="flex-100">
                        </mat-form-field>
                      </div>
                    }
                    @if (formField.type === 'NUM') {
                      <div>
                        <mat-form-field appearance="fill" class="flex-align-center flex-100">
                          <input matInput [formControlName]="formField.jsonProperty" [type]="'number'" class="flex-100">
                        </mat-form-field>
                      </div>
                    }
                    @if (formField.type === 'BOOL') {
                      <div>
                        <mat-form-field appearance="fill" class="flex-align-center flex-100">
                          <mat-select [formControlName]="formField.jsonProperty" class="flex-100">
                            @for (option of formField.options; track option) {
                              <mat-option
                                [value]="option.value">{{ option.label }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                    }
                    @if (formField.type === 'TEXTAREA') {
                      <div>
                        <mat-form-field appearance="fill" class="flex-align-center flex-100">
                          <textarea matInput
                            cdkTextareaAutosize
                            cdkAutosizeMinRows="3"
                            [formControlName]="formField.jsonProperty" class="flex-100">
                          </textarea>
                        </mat-form-field>
                      </div>
                    }
                    @if (formField.type === 'SELECT') {
                      <div>
                        <mat-form-field appearance="fill" class="flex-align-center flex-100">
                          <mat-select [formControlName]="formField.jsonProperty" class="flex-100">
                            @for (option of formField.options; track option) {
                              <mat-option
                                [value]="option.value">{{ option.label }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                    }
                    @if (formField.type === 'MULTI_SELECT') {
                      <div>
                        <mat-form-field appearance="fill" class="flex-align-center flex-100">
                          <mat-select [formControlName]="formField.jsonProperty"
                            multiple class="flex-100">
                            @for (option of formField.options; track option) {
                              <mat-option
                                [value]="option.value">{{ option.label }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                    }
                    @if (formField.type === 'IMAGE') {
                      <div>
                        <mat-form-field appearance="fill" class="flex-align-center flex-100">
                          <input matInput [formControlName]="formField.jsonProperty" [type]="'text'" class="flex-100">
                        </mat-form-field>
                      </div>
                    }
                  </div>
                </div>
              }
            </form>
          }
        </mat-card>
      </mat-tab>
    </mat-tab-group>
  }
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-actions-fixed">
  <button mat-raised-button color="primary" type="button" mat-dialog-close (click)="close()">
    Cancel
  </button>

  <button mat-raised-button color="primary" type="submit"
    [disabled]="form?.invalid || templateForm?.invalid || !selectedLocationSetType || !selectedLocationSet"
    (click)="save()">
    <mat-icon aria-hidden="true">save</mat-icon>
    Save
  </button>
</mat-dialog-actions>
<div class="info-message-container-footer">
  <mat-icon>info</mat-icon>
  <span>This variation will not be used anywhere in the menu until there are assignments on it</span>
</div>
